Information required to generate the Apply with SEEK button link.
